export default __webpack_public_path__ + "assets/models/afbbd0512b949edc743b222546e52795.glb";